(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dbux-runtime"] = factory();
	else
		root["dbux-runtime"] = factory();
})((typeof globalThis !== "undefined" ? globalThis : (typeof self !== "undefined" ? self : this)), function() {
return 